export default function Step2DataEdit({
  msg,
  register,
  nameBoat,
  boatOption,
  onSelectBoat,
  onClickClose,
  onClickBack,
  onClickSubmit,
  title,
}) {
  return (
    <div className="step_selection">
      <div className="title_step_selection">{title}</div>
      <div className="step_indicator">
        <div className="point">
          <div className="pass">1</div>
          <p>{msg.select_tour_and_date}</p>
        </div>
        <span className="pass" />
        <div className="point">
          <div className="pass">2</div>
          <p>{msg.select_boat}</p>
        </div>
      </div>
      <div className="container_step_2">
        <div className="boat_selection_and_passenger">
          <div className="_input_text_select select_boat">
            <label>{`${msg.boat_name} *`}</label>
            <select
              {...register(nameBoat, {
                required: true,
                onChange: onSelectBoat,
              })}
            >
              {boatOption.map((el, index) => (
                <option key={index} value={el.value} label={el.label} />
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="footer_button">
        <span className="left">
          <button onClick={onClickBack}>
            {"< "}
            {msg.back}
          </button>
        </span>
        <span className="right">
          {onClickClose && <button onClick={onClickClose}>{msg.close}</button>}
          <button onClick={onClickSubmit}>{msg.submit}</button>
        </span>
      </div>
    </div>
  );
}
